import { isObject } from '@/helpers/is';

/**
 * Reads the logged in user from the `userInfo` cookie.
 * Returns an empty object when the cookie is missing or unreadable.
 */
const getCurrentUser = () => {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  const userCookie = cookies.find((cookie) => cookie.startsWith('userInfo=')) || '';

  if (!userCookie) return {};

  try {
    const userCookieValue = JSON.parse(decodeURIComponent(userCookie.replace('userInfo=', '')));
    return isObject(userCookieValue) ? userCookieValue : {};
  } catch {
    return {};
  }
};

const getCurrentUserFullName = () => {
  const { firstName, lastName } = getCurrentUser();
  return `${firstName || ''} ${lastName || ''}`.trim();
};

export { getCurrentUser, getCurrentUserFullName };
